import { Box, styled } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';

export const PageContentWrapper = styled(Box, {
  maxWidth: CONTENT_MAX_WIDTH,
  boxSizing: 'content-box',
  padding: '0 $two $two',
  margin: 'auto',
  '@mobile': {
    padding: '0 $oneAndHalf $two',
  },
});
